import { useState } from 'react';

import { ContactDetailPanel } from '../../components/contacts/ContactDetailPanel';
import { ContactsTable } from '../../components/contacts/ContactsTable';
import { ImportModal } from '../../components/contacts/ImportModal';
import { Button } from '../../components/ui/button';
import type { ContactListFilters } from '../../api/types';

export function ContactsPage() {
  const [filters, setFilters] = useState<ContactListFilters>({ limit: 50 });
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [importOpen, setImportOpen] = useState(false);

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center justify-between border-b border-border px-4 py-3">
        <h1 className="text-lg font-semibold">Контакты</h1>
        <Button onClick={() => setImportOpen(true)}>Импорт</Button>
      </div>
      <div className="flex min-h-0 flex-1">
        <div className="min-w-0 flex-1">
          <ContactsTable
            filters={filters}
            onFiltersChange={setFilters}
            selectedId={selectedId}
            onSelect={setSelectedId}
          />
        </div>
        {selectedId && <ContactDetailPanel contactId={selectedId} onClose={() => setSelectedId(null)} />}
      </div>
      <ImportModal open={importOpen} onClose={() => setImportOpen(false)} />
    </div>
  );
}
